import { render, staticRenderFns } from "./ContactQuestionComponent.vue?vue&type=template&id=88656044&scoped=true"
import script from "./ContactQuestionComponent.vue?vue&type=script&lang=js"
export * from "./ContactQuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./ContactQuestionComponent.vue?vue&type=style&index=0&id=88656044&prod&lang=css"
import style1 from "./ContactQuestionComponent.vue?vue&type=style&index=1&id=88656044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88656044",
  null
  
)

export default component.exports